import { db, RepairReport } from 'technical/db';

type BackendRepairReport = Omit<RepairReport, 'desynchronizedAt' | 'deletedAt'>;

export const repairReportSyncService = {
  async download(repairs: BackendRepairReport[]): Promise<void> {
    await db.repairReports.bulkPut(
      repairs.map((repair) => ({
        ...repair,
        desynchronizedAt: null,
        deletedAt: null,
      })),
    );
  },

  async getUnsyncedBatch(limit: number): Promise<RepairReport[]> {
    return db.repairReports
      .filter((repair) => repair.desynchronizedAt !== null)
      .limit(limit)
      .toArray();
  },

  async markAsSynchronized(ids: string[]): Promise<void> {
    await db.repairReports.bulkUpdate(
      ids.map((id) => {
        return {
          key: id,
          changes: {
            desynchronizedAt: null,
          },
        };
      }),
    );
  },

  async reset(): Promise<void> {
    await db.repairReports.clear();
  },
};
